import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import NetWorth from '../../views/NetWorth/NetWorth';
import Assets from '../../views/Assets/Assets';
import Debts from '../../views/Debts/Debts';
import AddAccount from '../../views/AddAccount/AddAccount';
import EditBurnRate from '../../views/EditBurnRate/EditBurnRate';
import Modal from '../../components/UI/Modal';

import styles from './Dashboard.module.css';
import { getExchangeRates } from '../../store/actions/exchangeRatesActions';

const Dashboard: React.FC = () => {
  const dispatch = useDispatch();
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [showBurnRateModal, setShowBurnRateModal] = useState(false);

  useEffect(() => {
    dispatch(getExchangeRates());
    console.log('requesting exchange rates...')
  }, [dispatch]);

  return (
    <div>
      <NetWorth
        onAddAccount={() => setShowAccountModal(true)}
        onEditBurnRate={() => setShowBurnRateModal(true)}
      />
      <div className={styles.assetsAndDebts}>
        <Assets />
        <Debts />
      </div>
      {showAccountModal ? (
        <Modal onBackdropClick={() => setShowAccountModal(false)}>
          <AddAccount onSubmit={() => setShowAccountModal(false)} />
        </Modal>
      ) : null}
      {showBurnRateModal ? (
        <Modal onBackdropClick={() => setShowBurnRateModal(false)}>
          <EditBurnRate onSubmit={() => setShowBurnRateModal(false)} />
        </Modal>
      ) : null}
    </div>
  );
};

export default Dashboard;
